import dayjs from "dayjs"
import moment from "moment"

export function readableTime(timeInMills: any) {
  const now = moment()
  const time = moment(timeInMills)
  if (now.year() == time.year()) {
    return time.format("MM-DD HH:mm:ss")
  } else {
    return time.format("YYYY-MM-DD HH:mm:ss")
  }
}

export function readableDate(timeInMills: any) {
  const now = moment()
  const time = moment(timeInMills)
  if (now.year() == time.year()) {
    return time.format("MM-DD")
  } else {
    return time.format("YYYY-MM-DD")
  }
}

export function yyyymmdd(timeInMills: any) {
  const now = moment()
  const time = moment(timeInMills)
  return time.format("YYYY-MM-DD")
}

export function yyyymmddhhmmss(timeInMills: any) {
  const now = moment()
  const time = moment(timeInMills)
  return time.format("YYYY-MM-DD HH:mm:ss")
}

export function sleep(ms: number): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, ms)
  })
}

export function calculateAge(birthday: number) {
  const birthDate = dayjs(birthday)
  const now = dayjs()

  // 计算年龄，只考虑年份差异
  let age = now.year() - birthDate.year()

  // 如果今年的生日还没过，则减去一年
  if (now.month() < birthDate.month() || (now.month() === birthDate.month() && now.date() < birthDate.date())) {
    age--
  }

  return age
}
